// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"799":"6f9c1f0e","837":"ce85ca33"}[chunkId] + ".chunk.js";
};